import ChartDepressiviteit from "../../../../src/client/examples/json/depressiviteit.json";
import * as React from 'react';
export default {
  ChartDepressiviteit,
  React
};